import Loading from './../../../Loading'
import { useEffect, useState } from 'react'

const PlatformItem = ({ item, checkedState, onChange }) => (
  <li>
    <label htmlFor={`platform-${item.id}`}>
      <input
        type="checkbox"
        value={item.id}
        checked={checkedState.includes(item.id)}
        onChange={onChange}
        name={`platform-${item.id}`}
        id={`platform-${item.id}`}
      />
      {item.parentId == null ? <b>{item.title}</b> : item.title}
    </label>
    {item.children?.length > 0 && (
      <ul style={{ marginRight: '20px' }}>
        {item.children.map((child) => (
          <PlatformItem
            key={child.id}
            item={child}
            checkedState={checkedState}
            onChange={onChange}
          />
        ))}
      </ul>
    )}
  </li>
)

const PlatformsPost = ({ data, pullback, checked }) => {
  const [checkedState, setCheckedState] = useState([])

  useEffect(() => {
    if (checked) setCheckedState(checked)
  }, [checked])

  const handleOnChangeCheckBoxs = (event) => {
    const val = parseInt(event.target.value)

    if (event.target.checked) {
      setCheckedState((prev) => [...prev, val])
      pullback((prev) => [...prev, val])
    } else {
      const arryCopy = [...checkedState]
      const index = arryCopy.indexOf(val)
      if (index > -1) {
        arryCopy.splice(index, 1)
        setCheckedState(arryCopy)
        pullback(arryCopy)
      }
    }
  }

  return (
    <div className="boxHolderPosts">
      <div className="titleBar">پلتفرم‌ها</div>
      <div className="boxPost">
        <ul>
          {data ? (
            data.map((item) => (
              <PlatformItem
                key={item.id}
                item={item}
                checkedState={checkedState}
                onChange={handleOnChangeCheckBoxs}
              />
            ))
          ) : (
            <Loading styles="mini" />
          )}
        </ul>
      </div>
    </div>
  )
}

export default PlatformsPost
